export const FETCH_COMPLETED_RESULTS_REQUEST = "VIEW_COMPLETED_RESULTS_REQUEST";
export const FETCH_COMPLETED_RESULTS_SUCCESS = "VIEW_COMPLETED_RESULTS_SUCCESS";
export const FETCH_COMPLETED_RESULTS_FIALURE = "VIEW_COMPLETED_RESULTS_FAILURE";